<!--
 * @Description: 电子票页
 * @Author: 山淑兰
 * @Date: 2019-11-12 15:16:19
 * @LastEditTime: 2020-04-27 13:37:07
 * @LastEditors: 山淑兰
 -->
<template>  
  <div id="electronicTicket">
    <Loading v-if="show"></Loading>
    <div class="electronicTicket_container" v-else>
      <div class="screenshotPart">
        <div class="electronicTicket-banner">
          <img :src="meetingInfo.MobileBannerImage" alt />
        </div>
        <div class="loading" v-if="!showCon">
          <van-loading
            type="spinner"
            color="#3b82f6"
            vertical
            size="30px"
            text-size="16px"
            >{{ loadingMsg }}</van-loading
          >
        </div>
        <div
          class="electronicTicket_content commonW"
          v-else-if="showCon"
          ref="imageDom"
        >
          <div class="electronicTicket_fareInformation">
            <div class="fareInformation_header">
              <div class="fareInformation_header_nameInfo">
                <span>{{ userInfo.username }}</span>
                <span>({{ userInfo.userphone }})</span>
              </div>
            </div>
            <div class="fareInformation_content" v-if="!userInfo.ischeckin">
              <div class="QR-code">
                <div id="qrcode"></div>
              </div>
              <span class="noSignIn">未签到</span>
              <div class="QR-code_msg">请在活动现场出示此二维码</div>
            </div>
            <div class="fareInformation_content success" v-else>
              <h2>已签到</h2>
              <p>欢迎您参加本次会议！</p>
            </div>
            <div class="conferenceInfo">
              <ul class="conferenceInfo_lists">
                <li class="onferenceInfo_lists_item">
                  <div>{{ meetingInfo.MeetingTitle }}</div>
                  <!-- <van-icon name="arrow" /> -->
                </li>
                <li class="onferenceInfo_lists_item">
                  <div class="lists_item_tit">时间：</div>
                  <div class="onferenceInfo_item_date lists_item_cont">
                    {{ date }}
                  </div>
                </li>
                <li class="onferenceInfo_lists_item" @click="toAddress()">
                  <div class="lists_item_tit">地点：</div>
                  <div class="lists_item_cont">{{ address }}</div>
                  <van-icon name="arrow" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="download_btn commonW" v-show="showCon">
        <div class="download_btn_container">
          <span @click="clickGeneratePicture()">
            <span>保存电子票</span>
            <img src="@assets/down.png" alt class="downloadIcon" />
          </span>
        </div>
        <van-popup v-model="showDownloadImg" closeable>
          <div class>长按图片保存二维码</div>
          <div class="DownloadImgs">
            <img :src="imgUrl" alt />
          </div>
        </van-popup>
      </div>
      <Back></Back>
    </div>
    <div id="csbase64"></div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import wxShare from '../../lib/wxShare.js'
import commonMeans from '../../lib/signUp.js'
import QRCode from 'qrcodejs2'
import Loading from '@components/Loading.vue'
import Back from './components/backBtn.vue'

export default {
  name: 'electronicsignin',
  components: {
    Loading,
    Back
  },
  data() {
    return {
      address: '',
      imgUrl: '',
      showDownloadImg: false,
      lats: {},
      headRess: '',
      show: true, //加载动画
      showCon: false,
      loadingMsg: '加载中...',
      commonMeans: {}, //通用commonMeans
      meetingInfo: {}, //会议基本数据
      userInfo: {}, //用户信息
      date: '',
      time: '',
      showCode: 0
    }
  },

  created() {
    this.commonMeans = new commonMeans()
    let iswx = this.isWeiXin()

    // ==========
    if (process.env.NODE_ENV !== 'development' && !iswx) {
      this.init()
    }
  },
  mounted() {
    this.getQR_code()
    setInterval(() => {
      this.getQR_code()
    }, 1000)
  },
  methods: {
    //生成二维码
    qrcode(link) {
      new QRCode('qrcode', {
        width: 154,
        height: 140, // 高度
        text: link, // 二维码内容
        render: 'table', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        correctLevel: QRCode.CorrectLevel.H
      })
    },

    //获取二维码
    async getQR_code() {
      let params = {
        code: this.$route.query.code
      }
      let res = await this.$http.InitOpenCheckUser(params)

      let _CurUserEntity = res.CurUserEntity
      if (res.Code === 1000) {
        this.showCon = true

        if (!_CurUserEntity.ischeckin && !this.showCode) {
          this.userInfo = _CurUserEntity
          // this.$nextTick(() => {
          setTimeout(() => {
            this.qrcode(res.CoderKey)
          }, 0)
          // })
          this.showCode = 1
        } else if (_CurUserEntity.ischeckin !== this.userInfo.ischeckin) {
          this.userInfo = _CurUserEntity
          this.showCode = 0
        }

        this.loading = true

        this.meetingInfo = res.MeetingEntity
        this.address = this.meetingInfo.meetingaddress
        this.date = this.meetingInfo.TimerSpan
        console.log(this.meetingInfo)
        this.show = false
      }

      this.initMap(this.address)
    },

    // =------
    // 点击保存图片
    async clickGeneratePicture() {
      setTimeout(() => {
        this.showDownloadImg = true
        this.$nextTick(async () => {
          const _canvas = await html2canvas(this.$refs.imageDom, {
            backgroundColor: 'transparent',
            useCORS: true,
            logging: false
          })
          // 转成图片，生成图片地址,将图片地址赋给弹框中
          const url = _canvas.toDataURL('image/jpeg')
          this.imgUrl = url
        })
      }, 500)
    },
    // -----------------------
    initMap(address) {
      let thisd = this
      var AMap = window.AMap
      new AMap.Map('mapContainer', {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 12 //初始地图级别
      })
      AMap.plugin('AMap.Geocoder', function() {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          // city: '010'
        })
        geocoder.getLocation(address, function(status, result) {
          // console.log(status, result, '++++')
          if (status === 'complete' && result.info === 'OK') {
            const { geocodes } = result
            // const { formattedAddress, location } = geocodes[0]
            const { location } = geocodes[0]
            const { lat, lng } = location
            thisd.lats = { lat, lng }
          }
        })
      })
    },
    //判断是否为微信访问
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    async init() {
      try {
        const headRes = await this.$http.csData({
          url: encodeURIComponent(
            window.location.href.replace(location.hash, '')
          )
        })
        console.log(headRes, 'headRes')
        const _Wx = new wxShare({
          opt: headRes
        })
        this.headRess = _Wx
      } catch (err) {
        console.log(err)
      }
    },
    // 打开地图
    toAddress() {
      if (this.isWeiXin()) {
        console.log(this.lats, 'this.lats')
        let lat = this.lats.lat
        let lng = this.lats.lng
        console.log(lat, lng, '21')
        this.headRess.ready().then(wx => {
          this.headRess.map(
            lat,
            lng,
            this.meetingInfo.city,
            this.meetingInfo.meetingaddress
          )
          console.log(wx)
        })
      } else {
        window.location.href = `https://m.amap.com/search/mapview/keywords=${this.address}&cluster_state=5&pagenum=1`
      }
    }
  }
}
</script>
<style lang="scss">
#electronicTicket {
  .van-icon-cross {
    color: #fff;
    font-size: 38px;
    top: 30px;
  }
  #qrcode {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
.commonW {
  width: 92%;
  margin: 0 auto;
}
// -----------------
#electronicTicket {
  padding-bottom: 100px;
  .electronicTicket_container {
    .screenshotPart {
      padding-bottom: 20px;
    }
    .electronicTicket-banner {
      > img {
        width: 100%;
      }
    }
    .electronicTicket_content {
      background: #fff;
      margin: 40px auto;
      box-shadow: 0 2px 12px rgba(0,0,0,0.04); border: 1px solid #e2e8f0;
      .electronicTicket_fareInformation {
        width: 90%;
        margin: 0 auto;
        .fareInformation_header {
          font-size: 28px;
          color: #475569;
          line-height: 60px;
          padding: 20px 0;
          border-bottom: 2px solid #e2e8f0;
          .fareInformation_ticketPrice_price {
            margin: 0 10px;
            font-size: 34px;
          }
        }
        .fareInformation_content {
          width: 100%;
          padding: 60px 0 30px;
          border-bottom: 2px dashed #e2e8f0;
          margin-bottom: 10px;
          position: relative;
          text-align: center;
          line-height: 60px;
          font-size: 32px;
          color: #67C23A;
          &::after {
            content: '';
            width: 30px;
            height: 30px;
            position: absolute;
            left: -8%;
            bottom: 0;
            transform: translateY(50%);
            background: transparent;
            border-radius: 30px;
          }
          &::before {
            content: '';
            width: 30px;
            height: 30px;
            position: absolute;
            right: -8%;
            bottom: 0;
            transform: translateY(50%);
            background: transparent;
            border-radius: 30px;
          }
          .QR-code {
            width: 280px;
            height: 280px;
            margin: 0 auto;
            text-align: center;
            border: 2px solid #e2e8f0;
            padding: 20px;
          }
          .noSignIn {
            color: #f56c6c;
          }
          .QR-code_msg {
            color: #94a3b8;
            font-size: 24px;
          }
        }
        .success {
          height: 414px;
          padding: 60px 0 60px;
          text-align: center;
          > h2 {
            margin-top: 20%;
          }
        }
        .conferenceInfo {
          .conferenceInfo_lists {
            font-size: 28px;
            .onferenceInfo_lists_item {
              line-height: 80px;
              border-bottom: 2px solid #e2e8f0;
              position: relative;
              padding-right: 2%;
              color: #475569;
              display: flex;
              align-items: center;
              &:last-child {
                border-bottom: 0;
              }
              .onferenceInfo_item_date {
                margin-right: 10px;
              }
              > .van-icon {
                font-size: 40px;
                color: #94a3b8;
                position: absolute;
                top: 50%;
                right: -2%;
                transform: translateY(-50%);
              }
              .lists_item_tit {
                margin-right: 5%;
              }
              .lists_item_cont {
                flex: 1;
                margin-right: 20px;
                line-height: 40px;
              }
            }
          }
        }
      }
    }

    .download_btn {
      .download_btn_container {
        text-align: right;
        font-size: 24px;
        .downloadIcon {
          width: 30px;
        }
      }
      .van-popup {
        width: 80%;
        height: 80%;
        background-color: rgba(0, 0, 0, 0);
        overflow-y: hidden;
        > div {
          height: 60px;
          font-size: 30px;
          line-height: 100px;
          height: 100px;
          text-align: center;
          color: #fff;
        }
        .DownloadImgs {
          width: 100%;
          height: 80%;
          overflow-y: scroll;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
